module.exports = __webpack_public_path__ + "static/media/success-primary.0b7fc286.svg";